'use client';

import * as React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';

import config from '@src/config';
import { createTheme } from '@src/styles/theme/create-theme';
import { useSettings } from "@src/hooks";

export function ThemeProvider({ children }) {
  const { settings } = useSettings();

  const theme = createTheme({
    primaryColor: settings.primaryColor,
    colorScheme: settings.colorScheme,
    direction: settings.direction,
  });

  return (
    <CssVarsProvider defaultColorScheme={config.SITE.colorScheme} defaultMode={config.SITE.colorScheme} theme={theme}>
      <Helmet>
        <meta content={config.SITE.colorScheme} name="color-scheme" />
      </Helmet>
      <CssBaseline />
      {children}
    </CssVarsProvider>
  );
}
